import React from 'react';

import './Input.scss';

export interface InputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  onChange?: (value: string) => void;
}

const Input = ({ className, onChange, ...props }: InputProps) => (
  <input
    className={`input ${className}`}
    onChange={(e) => onChange?.(e.target.value)}
    {...props}
  />
);

Input.defaultProps = {
  onChange: () => {},
};

export default Input;
